import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'bloko/blocks/modal/modal.less';

/**
 *  Компонент, предназначенный для показа ошибки в модальных окнах
 */
export default function ModalError({ visible, children, ...modalErrorProps }) {
    return (
        <div
            {...modalErrorProps}
            className={classnames('bloko-modal-error', {
                'bloko-modal-error_hidden': !visible,
            })}
        >
            {children}
        </div>
    );
}

ModalError.propTypes = {
    /** Текст ошибки */
    children: PropTypes.node,
    /** Показывать ли ошибку */
    visible: PropTypes.bool,
};

ModalError.defaultProps = {
    visible: false,
};
